import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordInput({
  className = "",
  containerClassName = "",
  disabled = false,
  ...inputProps
}) {
  const [isVisible, setIsVisible] = useState(false);
  const toggleLabel = isVisible ? "Hide password" : "Show password";

  return (
    <div className={`relative ${containerClassName}`.trim()}>
      <input
        {...inputProps}
        type={isVisible ? "text" : "password"}
        disabled={disabled}
        className={`${className} pr-11`.trim()}
      />
      <button
        type="button"
        aria-label={toggleLabel}
        aria-pressed={isVisible}
        title={toggleLabel}
        disabled={disabled}
        onClick={() => setIsVisible((visible) => !visible)}
        className="absolute inset-y-0 right-0 flex w-11 items-center justify-center rounded-r-xl text-neutral-500 transition hover:text-neutral-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-neutral-400 disabled:cursor-not-allowed disabled:opacity-50 dark:text-neutral-400 dark:hover:text-neutral-100 dark:focus-visible:ring-neutral-500"
      >
        {isVisible ? (
          <EyeOff className="h-4 w-4" aria-hidden="true" />
        ) : (
          <Eye className="h-4 w-4" aria-hidden="true" />
        )}
      </button>
    </div>
  );
}
